import { render } from "./ColorMode.vue?vue&type=template&id=8869f4d4"
import script from "./ColorMode.vue?vue&type=script&lang=js"
export * from "./ColorMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__